<template>
  <div v-if="value" class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50" role="dialog" aria-modal="true" style="z-index: 1000">
    <div :class="fullscreen ? 'relative w-full h-full p-0' : 'relative w-full max-w-2xl mx-auto p-4 max-h-full'">
      <div :class="fullscreen ? 'flex flex-col h-full bg-white dark:bg-gray-700' : 'relative bg-white rounded-lg shadow-sm dark:bg-gray-700'">

        <!-- Header -->
        <div :class="fullscreen ? 'flex items-center justify-between p-4 border-b dark:border-gray-600 border-gray-200' : 'flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600 border-gray-200'">
          <slot name="header">
            <h3 class="text-xl font-semibold text-gray-900 dark:text-white">{{ title }}</h3>
          </slot>
          <button
            @click="close"
            type="button"
            class="text-gray-400 hover:text-gray-900 hover:bg-gray-200 dark:hover:text-white dark:hover:bg-gray-600 rounded-lg w-8 h-8 inline-flex justify-center items-center border"
          >
            <i class="fas fa-times"></i>
            <span class="sr-only">Close modal</span>
          </button>
        </div>
        <!-- Body -->
        <div :class="fullscreen ? 'flex-1 overflow-y-auto p-4' : 'p-4 md:p-5 space-y-4 overflow-y-auto max-h-96 min-h-96'">
          <slot />
        </div>

        <!-- Footer -->
        <div
          v-if="$slots.footer"
          :class="fullscreen ? 'p-4 border-t dark:border-gray-600 border-gray-200 gap-2 justify-end' : 'flex items-center p-4 md:p-5 border-t border-gray-200 rounded-b dark:border-gray-600 gap-2 justify-end'"
        >
          <slot name="footer" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'BaseModal',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      value: ''
    }
  },
  methods: {
    close() {
      this.$emit('close');
    }
  }
};
</script>
